import React, { useState, useEffect } from 'react';
import './StrukturOrganisasi.css';

const StrukturOrganisasi = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Memastikan halaman tidak dimuat dalam iframe
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="struktur-organisasi-container">
      {/* Header Section */}
      <header className="header-section">
        <div className="header-content">
          <h2>STRUKTUR ORGANISASI UPI YPTK</h2>
          <hr className="header-line" />
        </div>
      </header>

      {/* Image Section */}
      <div className="image-container">
        <img 
          src="/struktur/struktur-organisasi-revisi.jpg" 
          alt="Struktur Organisasi" 
          className="struktur-image" 
          onClick={openModal}  // Menambahkan event untuk membuka modal saat gambar diklik
          loading="lazy" // Optimalkan loading gambar
        />
      </div>

      {/* Modal Pop-up */}
      {isModalOpen && (
        <div 
          className="modal" 
          role="dialog" 
          aria-modal="true" 
          onClick={closeModal} // Tutup modal jika klik di luar konten
        >
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()} // Prevent click event bubbling
          >
            <button 
              className="close-btn" 
              aria-label="Close modal" 
              onClick={closeModal}
            >
              &times;
            </button>
            <img 
              src="/struktur/struktur-organisasi.jpg" 
              alt="Struktur Organisasi" 
              className="modal-image" 
              loading="lazy" 
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StrukturOrganisasi;
